<template>
  <dialog-modal
    :show="show"
    @close="$emit('close')">
    <template #title>
      <div
        v-if="isBlankForm"
        class="flex justify-center font-bold">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <div
          class="ml-2 text-red-500">
          学生情報を入力してください
        </div>
      </div>
    </template>
    <template #content>
      <div>
        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          学校名
          <input
            v-model="schoolInfoState.school"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          学部・学科
          <input
            v-model="schoolInfoState.department"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          学校メールアドレス<br />※任意
          <input
            v-model="schoolInfoState.schoolEmail"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          入学年月
          <input
            v-model="schoolInfoState.dateOfAdmission"
            type="date"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>

        <div
          class="grid grid-cols-4 text-black py-2 items-center rounded border-blue-400">
          学籍番号
          <input
            v-model="schoolInfoState.studentId"
            type="text"
            class="ml-2 pl-2 col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
        </div>
      </div>
    </template>
    <template #footer>
      <button
        class="px-8 py-2 rounded bg-blue-600 hover:bg-blue-400 text-blue-50 max-w-max shadow-sm hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="isBlankForm"
        @click="$emit('checkout-click', examination)">
        決済に進む
      </button>
      <button
        class="px-8 py-2 m-5 rounded bg-red-500 hover:bg-red-400 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
        @click="$emit('back-click')">
        戻る
      </button>
    </template>
  </dialog-modal>
</template>

<script setup>
import {
  computed,
} from 'vue'
import DialogModal from '../../../Common/DialogModal.vue'

const props = defineProps({
  schoolInfoState: {
    type: Object,
    default: () => ({}),
  },
  show: {
    type: Boolean,
    default: () => false,
  },
})

const emit = defineEmits(['checkout-click', 'back-click', 'outside-click', 'close'])

const isBlankForm = computed(() => {
  let isBlank = false
  if (!props.schoolInfoState.school
      || !props.schoolInfoState.department
      || !props.schoolInfoState.schoolEmail
      || !props.schoolInfoState.dateOfAdmission
      || !props.schoolInfoState.studentId) {
    isBlank = true
  }
  return isBlank
})

</script>
